import { useCallback, useEffect } from 'react';
import { isSome } from 'fp-ts/Option';

import { CreateDashboardCriteriaBuilder } from 'use-case/dashboard/create/createDashboardCriteria';
import { CriteriaCallback } from 'adapter/in/common/hooks/useCase';
import { useDashboards } from 'adapter/in/dashboards/context/Dashboards';
import { useNavigation } from 'adapter/in/common/hooks/useNavigation';

const useCreateDashboard = (): { success: boolean; isLoading: boolean; error: boolean; create: CriteriaCallback } => {
    const { navigationPush } = useNavigation();
    const { create, createResult, createError, createIsLoading, createReset } = useDashboards();

    const handleCreate = useCallback((name: string) => create(CreateDashboardCriteriaBuilder.create().withName(name).build()), []);

    useEffect(() => {
        if (isSome(createResult)) {
            navigationPush(`${createResult.value.id}/edit`);
        }
        return () => createReset && createReset();
    }, [createResult]);

    return {
        success: isSome(createResult),
        isLoading: createIsLoading,
        error: isSome(createError),
        create: handleCreate,
    };
};

export default useCreateDashboard;
